export default __webpack_public_path__ + "static/media/CarWrapping.5e0837b0.webp";